import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { type Schema as PMSchema } from '@atlaskit/editor-prosemirror/model';

import type { StepsDatabase } from '../stepsDatabase';
import type { EditorOfflineStoragePlugin } from '../editorOfflineStoragePluginType';

import { applyStepsCommand, noStepsCommand, retryCommand, tooManyRetriesCommand } from './commands';

const MAX_RETRIES = 1;

function handleRetry(api: PublicPluginAPI<EditorOfflineStoragePlugin> | undefined) {
	const sharedPluginState = api?.editorOfflineStorage?.sharedState.currentState();
	const retryCount = sharedPluginState?.retryCount ?? 0;
	if (retryCount >= MAX_RETRIES) {
		api?.core.actions.execute(tooManyRetriesCommand());
	} else {
		api?.core.actions.execute(retryCommand(retryCount));
	}
}

export function restoreStepsAction(
	api: PublicPluginAPI<EditorOfflineStoragePlugin> | undefined,
	stepsDatabase: StepsDatabase,
) {
	return async (pmSchema: PMSchema) => {
		try {
			const databases = await window.indexedDB.databases();
			const dbExists = Boolean(databases.find((db) => db.name === stepsDatabase.dbName));

			if (!dbExists) {
				api?.core.actions.execute(noStepsCommand());
				return;
			}

			const { steps } = await stepsDatabase.getData(pmSchema);
			const dispatched = api?.core.actions.execute(applyStepsCommand(steps));
			if (!dispatched) {
				handleRetry(api);
				return;
			}

			try {
				await stepsDatabase.clear();
			} catch (e) {
				// steps were applied but failed to clear, continue
			}
		} catch (e) {
			handleRetry(api);
		}
	};
}
